import $ from 'jquery';

$(() => {
    // Some people apparently press enter in textfield expecting a new line, instead it submits the form,
    // pressing the nearest button. Trying to prevent this.
    $('input:text').keypress(e => {
        if (e.which === 13) {
            e.preventDefault();
            return false;
        }
        return true;
    })
});
